export const CookiesPTBRTranslations = {
  cookiesText:
    'Utilizamos cookies para proporcionar uma melhor experiência, melhorar o desempenho e analisar a forma como interage com o nosso site. Ao clicar no botão, você consente com os cookies.',
  cookiesButtonText: 'Aceitar cookies',
};
